/* eslint-disable */
import React, { useState, useEffect } from "react";
// import { Form } from '@ant-design/compatible';
// import '@ant-design/compatible/assets/index.css';
import { Form, Input, Button, Result, Modal, message } from "antd";
import cookies from "js-cookie";
import { baseUrl, AWSCValidate} from "utils";
import HelpTip from "pages/components/helpTip";
import * as qs from "query-string";
import { userLogout } from "pages/myutils/user";
import "./index.css";
import { phoneReg } from "components/common";
import { formItemLayout, tailFormItemLayout } from "../../../login/layout";
import AddFn from "../../../manager/company/companyList/add";
import PathButton from "../../../login/components/pathButton";
import ImageCode from "pages/components/ImageCode";
import {showMessage} from "../../../../utils";
import { CodeNewButton } from "components/common";
const { axios } = window;

/**
 * 发送验证码按钮(旧)
 * @param {*} param0
 */
function CodeButton({ send, username, errorCallback, user }) {
    console.log(send)
    const [dis, setDis] = useState(false);
    const [num, setNum] = useState(0);
    const [loading, setLoading] = useState(false);
    const msg = dis ? `${num}s后重发` : "获取验证码";
    useEffect(() => {
        let id;
        if (dis) {
            if (num > 0) {
                id = setTimeout(() => {
                    setNum(prev => prev - 1);
                }, 1000);
            } else {
                setDis(false);
                setNum(0);
            }
        }
        return () => {
            clearTimeout(id);
        };
    }, [dis, num]);

    function sendCode() {
        setLoading(true);
        axios.get("/customer/code", { params: { username :username || user.self.phone  , effect: cookies.get("dingzhiBol"), codeType :1} })
            .then(({ status, data: { success, message } }) => {
                // console.log('response:', arguments[0])
                if (status !== 200 || !success) {
                    errorCallback(message);
                    return;
                }
                setNum(60);
                setDis(true);
            })
            .finally(() => {
                setLoading(false);
            });
    }
    return (
        <Button
            type="link"
            loading={loading}
            disabled={!send || dis}
            onClick={sendCode}
        >
            {msg}
        </Button>
    );
}



// /**
//  * 发送验证码按钮(新)
//  * @param {*} param
//  */
//  function CodeNewButton({ send, username, errorCallback, user, callbackhandleSc,
//     callbackhandleSend }) {
//     console.log(send)
//     const [form] = Form.useForm();
//     const [code, setCode] = useState(null);
//     const [resetCode, setresetCode] = useState(true);
//     const [visible, setVisible] = useState(false);
//     const [dis, setDis] = useState(false);
//     const [num, setNum] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [imgUrl, setImageUrl] = useState(``);

//     const msg = dis ? `${num}s后重发` : "获取短信验证码";
//     useEffect(() => {
//         let id;
//         if (dis) {
//             if (num > 0) {
//                 id = setTimeout(() => {
//                     setNum(prev => prev - 1);
//                 }, 1000);
//             } else {
//                 setDis(false);
//                 setNum(0);
//             }
//         }
//         return () => {
//             clearTimeout(id);
//         };
//     }, [dis, num]);
//   // 获取短信验证码
//   const onSubmit = values => {
//     console.log(values);
//     setLoading(true);
//     axios.get("/customer/code", { params: { username :username || user.self.phone  , effect: cookies.get("dingzhiBol"), codeType :1, preCode: values.code} })
//         .then(({ status, data: { success, message } }) => {
//             // console.log('response:', arguments[0])
//             if (status !== 200 || !success) {
//                 showMessage("error", message);
//                 changesImg();
//                 form.setFieldsValue({
//                     code: null
//                 });
//                 return;
//             }
//             showMessage("success", message);
//             setNum(60);
//             setDis(true);
//             form.setFieldsValue({
//                 code: null
//             });
//             setVisible(false);
//         })
//         .finally(() => {
//             setLoading(false);
//         });
//   };
//   const handleCancel = () => {
//     form.setFieldsValue({
//         code: null
//     });
//     setVisible(false);
//   };
//   const changesImg = () => {
//       document.getElementById("img").src = `${baseUrl}/customer/fetchShortMessagePreCode?phoneNumber=${username || user.self.phone}`+`&timestamp=${new Date().getTime()}`;
//   }
//     return (
//         <>
//             <Button
//                 type="link"
//                 loading={loading}
//                 disabled={!send || dis}
//                 onClick={() => {
//                     // setVisible(true);
//                     // setImageUrl(`${baseUrl}/customer/fetchShortMessagePreCode?phoneNumber=${username || user.self.phone}`+`&timestamp=${new Date().getTime()}`)

//                     callbackhandleSc(true);
//                     callbackhandleSend(false);
//                     AWSCValidate(
//                         {
//                         width: "324px",
//                         appkey: "FFFF0N0000000000B190",
//                         scene: "ic_other",
//                         renderTo: "phoneSc",
//                         mobile: username,
//                         codeType: 1
//                         },
//                         () => {
//                         callbackhandleSend(false);
//                         }
//                     );  
//                 }}
//             >
//                 {msg}
//             </Button>
//             {visible ? (
//                 <Modal
//                 title="请输入校验码"
//                 visible={visible}
//                 onCancel={handleCancel}
//                 footer={null}
//                 >
//                 <Form form={form} onFinish={onSubmit} validateTrigger="onBlur">
//                     <Form.Item
//                         name="code"
//                         style={{ marginBottom: 0 }}
//                         rules={[
//                             () => ({
//                               validator(rule, value) {
//                                 if (value) {
//                                   return Promise.resolve();
//                                 }
//                                 return Promise.reject("校验码不能为空");
//                               }
//                             })
//                         ]}
//                         // rules={[
//                         //     () => ({
//                         //     validator(rule, value) {
//                         //         if (value) {
//                         //         if (value.toLowerCase() !== code.toLowerCase()) {
//                         //             setresetCode(false);
//                         //             setTimeout(() => {
//                         //             setresetCode(true);
//                         //             }, 100);
//                         //             return Promise.reject("校验码错误");
//                         //         }
//                         //         return Promise.resolve();
//                         //         }
//                         //         return Promise.reject("请输入校验码");
//                         //     }
//                         //     })
//                         // ]}
//                         >
//                         <Input
//                             placeholder="请输入校验码"
//                             // suffix={
//                             //     resetCode && (
//                             //         <ImageCode
//                             //         setCode={num => {
//                             //             setCode(num);
//                             //         }}
//                             //         />
//                             //     )
//                             // }
//                             suffix={
//                                 <img id="img" src={imgUrl} alt="" />
//                             }
//                         />
//                         </Form.Item>
//                         <a style={{ float: "right" }} onClick={changesImg}>
//                             刷新
//                         </a>
//                         <Form.Item>
//                         <Button
//                             type="primary"
//                             htmlType="submit"
//                             className="form-button"
//                             style={{ background: "green !important" }}
//                             loading={loading}
//                             disabled={!send || dis}
//                         >
//                             确认
//                         </Button>
//                         </Form.Item>
//                     </Form>
//                 </Modal>
//             ) : (
//                 ""
//             )}
//         </>
        
//     );
// }

const FogetPwd = ({ onCacel, visible, title, user }) => {
    console.log(user)
    const { webType, companyid, customId, userId, tenantId } = qs.parse(location.search);
    const [sendCode, setSendCode] = useState(false);
    const [phone, setPhone] = useState(null);
    const [garbage, setGarbage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [scVisible, setScVisible] = useState(false);
    const [form] = Form.useForm();
    const [goTimer, setGoTimer] = useState(false);
    const appkey = "FFFF0N0000000000B190";
    const scene = "ic_other";
    useEffect(() => {
       if(title === "修改密码"){
        setSendCode(true)
       }
    }, []);
    function setError(k, msg) {
        form.setFields([
            {
                name: k,
                value: form.getFieldValue(k),
                errors: [msg],
                touched: true
            }
        ]);
    }
    const onSubmit = values => {
        setGarbage(null);
        setLoading(true);
        axios.post("/customer/regist", {
            username: values.phone,
            password: values.password,
            code: values.code,
            companyId: tenantId,
            customerId: customId,
            wenjuanId: userId
        }).then(({ status, data }) => {
            setLoading(false);
            // console.log('handleSubmit', status, data)
            if (status !== 200 || !data.success) {
                // todo something
                // cookies.remove('token', { path: '' })
                // (send.self.token)
                let msg;
                ["username", "password", "code"].forEach(k => {
                    msg = data[k + "Message"];
                    if (msg) {
                        k === "username" && (k = "phone");
                        setError(k, msg);
                    }
                });
                if (data.message) {
                    setGarbage({ validateStatus: "error", help: data.message });
                }
                return;
            }
            // 注册成功
            let content = ''
            if(title === "修改密码"){
                content= "您的密码修改成功，请重新登录"
            }else{
                content= "您的密码重置成功"
            }
            userLogout()
            Modal.info({
                content: content,
                onOk: () => {
                    window.location.href="/login"
                },
            })
        });
    };
    const validatePhone = (rule, value) => {
        if (phoneReg.test(value)) {
            setSendCode(true);
            setPhone(value);
            return Promise.resolve();
        }
        setSendCode(false);
        return Promise.reject("手机号码格式错误");
    };

    const compareToFirstPassword = (rule, value) => {
        if (!value) {
            return Promise.reject("请再次输入密码");
        }
        if (value !== form.getFieldValue("password")) {
            return Promise.reject("两次密码输入不一致");
        }
        return Promise.resolve();
    };
    // 获取短信验证码
  const getShortMsg = ({
    appkey,
    scene,
    sessionId,
    sig,
    token,
    mobile,
    codeType
  }) => {
    window.axios
      .get("/alibaba/verificationCode", {
        params: {
          appkey,
          scene,
          mobile,
          sessionId,
          sig,
          token,
          codeType
        }
      })
      .then(res => {
        if (res.data.success) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
      });
  };
    return (
        <Modal className="fogetStyle" title={title} closable={false} onClose={onCacel} visible={visible}  footer={false}>
            <Form
                {...formItemLayout}
                form={form}
                onFinish={onSubmit}
                initialValues={ title === "修改密码" ? {phone:user.self.phone} : {}}
                validateTrigger="onBlur"
            >
                <Form.Item
                    label="手机号"
                    name="phone"
                    validateFirst
                    style={{marginBottom:12}}
                    de
                    rules={[
                        {
                            required: true,
                            message: "请输入您的手机号码"
                        },
                        {
                            validator: validatePhone
                        }
                    ]}
                >
                    <Input 
                        placeholder="请输入11位手机号"
                        disabled={title === '修改密码'}
                        suffix={
                          <CodeNewButton
                            send={sendCode}
                            username={phone}
                            codeType={1}
                            callbackhandleSc={data => {
                              form.validateFields(["phone"]).then(value => {
                                console.log("value ", value);
                                setGoTimer(true);
                                getShortMsg({
                                  appkey,
                                  scene,
                                  ...data,
                                  mobile: value.phone,
                                  codeType: 2
                                });
                              });
                              // getShortMsg({})
                            }}
                            callbackhandleSend={visible => {
                              // 验证成功后将 获取验证码按钮禁用
                              setGoTimer(false);
                            }}
                            goTimer={goTimer}
                            renderTo="fogetPassSc"
                            visiblePass={visible}
                          />
                        }
                        onFocus={e => {
                            form.setFields([
                                {
                                name: "phone",
                                value: e.target.value,
                                errors: null
                                }
                            ]);
                        }}
                    />
                </Form.Item>
                <div id="fogetPassSc" />
                <Form.Item
                    label="短信验证码"
                    name="code"
                    validateFirst
                    rules={[
                        {
                            required: true,
                            message: "请输入短信验证码"
                        },
                        {
                            pattern: /^\d{4}$/,
                            message: "验证码格式错误"
                        }
                    ]}
                >
                    <Input
                        placeholder="请输入短信验证码"
                        onFocus={e => {
                            form.setFields([
                                {
                                name: "code",
                                value: e.target.value,
                                errors: null
                                }
                            ]);
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={
                        <span>
            密码&nbsp;
                            <HelpTip title="密码长度6-30位，至少包含数字、字母、特殊符号" />
          </span>
                    }
                    hasFeedback
                    name="password"
                    validateFirst
                    rules={[
                        {
                            required: true,
                            message: "请输入您的密码"
                        },
                        {
                            min: 6,
                            max: 30,
                            message: "密码长度为6-30位"
                        },
                        {
                            pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,30}$/,
                            // pattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,16}$/,
                            message: "密码长度6-30位，至少包含数字、字母、特殊符号"
                        }
                    ]}
                >
                    <Input.Password 
                        placeholder="请输入密码" 
                        onFocus={e => {
                            form.setFields([
                                {
                                name: "password",
                                value: e.target.value,
                                errors: null
                                }
                            ]);
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label="重复密码"
                    hasFeedback
                    dependencies={["password"]}
                    name="confirm"
                    validateFirst
                    rules={[
                        {
                            required: true,
                            message: "请重复输入密码"
                        },
                        {
                            validator: compareToFirstPassword
                        }
                    ]}
                >
                    <Input.Password 
                        placeholder="请再次输入密码" 
                        onFocus={e => {
                            form.setFields([
                                {
                                name: "confirm",
                                value: e.target.value,
                                errors: null
                                }
                            ]);
                        }}
                    />
                </Form.Item>
                <Form.Item {...garbage} className="error-box" />
                <Form.Item {...tailFormItemLayout}>
                    <div className="btns">
                        <Button onClick={onCacel}>取消</Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="form-button"
                            loading={loading}
                            style={{marginRight : 0}}
                        >
                            确定
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
}
export default FogetPwd;
